export default __webpack_public_path__ + "static/media/walkthrough2.c8082c45.PNG";